import { useCallback } from 'react';
import { api } from 'src/assets/static/ApiRoutes';
import useAsync from 'src/hooks/useAsync';
import { IAttachDocument } from 'src/types/AttachDocument';
import axiosInstance from 'src/utils/axios';

interface AttachDocumentRequest {
  id?: number;
  attachIds?: number[];
}

interface AttachDocumentResponse {
  totalRecords: number;
  items: IAttachDocument[];
}

const useAttachToReceiptOrInvoiceApi = (isInvoice: boolean) => {
  const call = useCallback(
    ({ id, attachIds }: AttachDocumentRequest = {}) =>
      new Promise<AttachDocumentResponse>((resolve, reject) => {
        axiosInstance
          .post<AttachDocumentResponse>(
            isInvoice
              ? api.addAttachmentsToInvoiceFn(id || 0)
              : api.addAttachmentsToReceiptFn(id || 0),
            attachIds
          )
          .then((data) => resolve(data.data))
          .catch((error) => {
            reject(error);
          });
      }),
    [isInvoice]
  );

  const { execute, isLoading, status } = useAsync(call, false);

  return {
    attachDocumentsToReceiptOrInvoice: execute,
    isAttachDocumentLoading: isLoading,
    status,
  };
};

export default useAttachToReceiptOrInvoiceApi;
